module.exports = __webpack_public_path__ + "img/ico_exclamation_triangle_red.b11a1cbf.svg";